import React, { FC } from 'react'
import { Categories } from './styles'

//* utils
import { backgroundThemes } from '../../../constants/contentfulStyle.constant'
import ImgUtil from '../../../utils/img.utils'

//* component
import Button from '../button'
import Typography from '../typography'
import WrapperImage from '../wrapperImage'

type Props = {
  data: any
  isDarkTheme: boolean
  uiPathUrl: string
}

export const ResourceCategories: FC<Props> = ({ data, isDarkTheme, uiPathUrl }) => {
  const categories = data.linkCategories?.map((category: any) => (
    <div className="ResourceLists__Category" key={category.id}>
      <header className="Category__Header">
        <span className="Category__Icon">
          <CategoryIcon
            colorImage={category.resourceCategory.colorImage}
            whiteImage={category.resourceCategory.whiteImage}
            isDarkTheme={isDarkTheme}
          />
        </span>

        <Typography type="header5" className="text Category_Title">
          {category.titleOverride || category.name}
        </Typography>
      </header>

      {category?.links?.map((link: any, i: number) => (
        <CategoryLink link={link} uiPathUrl={uiPathUrl} key={`category_link-${i}`} />
      ))}
    </div>
  ))

  const mid = Math.floor(categories.length / 2)

  return (
    <Categories $isDarkTheme={isDarkTheme}>
      <div className="ResourceLists__Categories_Left">{categories.slice(0, mid)}</div>
      <div className="ResourceLists__Categories_Right">{categories.slice(mid)}</div>
    </Categories>
  )
}

const setLinkUrl = (link: any, uiPathUrl: any) => {
  if (link?.externalUrl) {
    return link.externalUrl
  } else if (link?.slug) {
    return uiPathUrl + link.slug
  } else if (link?.internalLink) {
    return uiPathUrl + link.internalLink.slug
  } else {
    return uiPathUrl
  }
}

const CategoryIcon = ({ colorImage, whiteImage, isDarkTheme }: any) => {
  const logoUrl = colorImage?.image?.file?.url
  const whiteImg = whiteImage?.image?.file?.url
  const colorAltText = colorImage?.altText
  const whiteAltText = whiteImage?.altText
  const themeIcon = isDarkTheme ? whiteImg : logoUrl

  return (
    <WrapperImage
      src={ImgUtil.getResizedImageUrl(themeIcon, '')}
      width={40}
      height={30}
      alt={colorAltText || whiteAltText}
    />
  )
}

const CategoryLink = ({ link, uiPathUrl }: any) => {
  const linkText = link.ctaText || link.text || link.h1Title || link.hero?.headline

  return (
    <Button
      key={link.id}
      className="Category__Link"
      type={'inline-text-link'}
      theme={'light'}
      href={setLinkUrl(link, uiPathUrl)}
      text={linkText}
    />
  )
}

export const ResourceButton = ({ ctaLabelOverride, ctaList, theme, uiPathUrl }: any) => {
  const buttonText = ctaLabelOverride || ctaList?.text || ctaList?.pageName

  return (
    <div className="ResourceLists__ButtonWrapper">
      <Button
        className="ResourceLists__Button"
        type={'secondary'}
        theme={theme === backgroundThemes.DARK ? 'light' : 'dark'}
        href={setLinkUrl(ctaList, uiPathUrl)}
        text={buttonText}
      />
    </div>
  )
}
